import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";

const fetchResearchOpportunities = async (pageSize, pageNumber) => {
  return await axios.get(
    API_URL +
      `/api/Research/GetResearchOpportunities/${pageSize}/${pageNumber}`,
    {
      headers: securityHeaders,
    }
  );
};

const fetchResearchById = async (id) => {
  return await axios.get(
    API_URL + `/api/Research/GetResearchOpportunitiesById/${id}`,
    {
      headers: securityHeaders,
    }
  );
};

const fetchOpportunityTypes = async () => {
  return await axios.get(API_URL + `/api/Research/GetOpportunityTypes`, {
    headers: securityHeaders,
  });
};

export const useFetchResearchOpportunities = (pageSize, pageNumber) => {
  return useQuery({
    queryKey: ["researchOpportunities"],
    queryFn: () => fetchResearchOpportunities(pageSize, pageNumber),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchResearchById = (id) => {
  return useQuery({
    queryKey: [`researchById-${id}`],
    queryFn: () => fetchResearchById(id),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchOpportunityTypes = () => {
  return useQuery({
    queryKey: [`opportunityTypes`],
    queryFn: () => fetchOpportunityTypes(),
    enabled: true,
    refetchOnWindowFocus: false,
  });
};

const deleteResearch = (id) => {
  return axios.post(
    API_URL + `/api/Research/DeleteResearchOpportunity/${id}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useDeleteResearch = (id) => {
  return useMutation(() => deleteResearch(id));
};
